import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  destinationCityList: [],
};

export default function destinationCity(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 目的地数据
    case ACTION_TYPES.GET_DESTINATION_CITY:
      result.destinationCityList = payload && payload.length > 0 ? payload.map(item => {
        return {
          ...item,
          destinationDetail: item.secondList && item.secondList.length > 0 ? item.secondList.map(itemDetail => {
            return {
              ...itemDetail,
              foldDetail: itemDetail.thirdList.slice(0, 4),
              isShowLoadMoreText: itemDetail.thirdList && itemDetail.thirdList.length > 4 ? true : false,
            }
          }) : [],
        }
      }) : [];
      break;
      case ACTION_TYPES.GET_DESTINATION_CITY_CHANGE:
        console.log("payload", payload);
        result.destinationCityList = payload;
        break;
    default:
      result = state;
  }
  return result;
}